import { useLocalStorageState } from "src/hooks/use_local_storage_state"

import { LAST_SELECTED_CARD_READER, PREFIX } from "../storage_keys"

export const useSelectedCardReader = () =>
  useLocalStorageState(PREFIX, LAST_SELECTED_CARD_READER)
